export { default } from './src/Autocomplete';

export * from '@ott/select';

export type { AutocompleteProps } from './src/Autocomplete';
